import React from 'react';
import Modal from 'react-bootstrap/Modal';
import {css} from 'aphrodite';
import {renderMultifieldString} from 'libs/salmon-utils';
import Markdown from 'components/Markdown';

/**
 * New Wrapper component to handle state for the coverage summary modal
 */
export const CoverageSummaryModal = (props) => {
  const {
    column,
    rowData,
    styleSheet,
    showSummaryModal,
    handleHide,
  } = props;

  if (!rowData) {
    return null;
  }

  return (
    <Modal
      show={showSummaryModal}
      onHide={handleHide}
      aria-labelledby={'summary-modal-title'}
      backdrop={true}
      size='lg'
      backdropClassName={css(styleSheet.modalBackdrop)}
      dialogClassName={`pal-modal ${css(styleSheet.coverageSummaryModal)}`}
      className={css(styleSheet.modal)}
    >
      <Modal.Header closeButton>
        <Modal.Title id={'summary-modal-title'} className={'summary-modal-title'}>
          {column.meta && column.meta.title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className={'summary-modal-body'}>
        <div>
          <div style={{marginBottom: '15px'}}>
            <label className={css(styleSheet.coverageSummaryModalLabel)}>
              <span>{renderMultifieldString(column.meta?.subtitle, rowData)}</span>
            </label>
          </div>
          <Markdown>
            {column.meta?.template
              ? renderTemplateWithPlaceholders(column.meta.template, rowData)
              : (rowData[column.property] ?? '')}
          </Markdown>
        </div>
      </Modal.Body>
      {column.meta?.disclaimer &&
        <Modal.Footer className={css(styleSheet.coverageSummaryModalFooter)}>
          <Markdown>{column.meta?.disclaimer}</Markdown>
        </Modal.Footer>
      }
    </Modal>
  );
};

/**
 * Gets a field value from rowData, checking both direct properties and the fields array.
 * Used for template placeholders when data may come from rowData.fields (e.g. dynamic columns).
 */
const getFieldValueFromRowData = (rowData, key) => {
  if (!rowData) {
    return '';
  }

  if (rowData.hasOwnProperty(key) && rowData[key] !== undefined && rowData[key] !== null) {
    return rowData[key];
  }

  if (Array.isArray(rowData.fields)) {
    const field = rowData.fields.find((f) => f && f.fieldName === key);
    if (field && field.value !== undefined && field.value !== null) {
      return field.value;
    }
  }

  return '';
};

/**
 * Renders a template string by replacing [[fieldName]] placeholders with rowData values.
 * Supports both direct properties and rowData.fields array. Result is suitable for markdown.
 */
const renderTemplateWithPlaceholders = (template, rowData) => {
  if (!template || typeof template !== 'string') {
    return '';
  }

  return template.replace(/\[\[(.*?)\]\]/g, (match, key) => {
    let foundValue = getFieldValueFromRowData(rowData, key);
    if (foundValue && Array.isArray(foundValue)) {
      return foundValue.sort().join(', ');
    }
    return foundValue || '';
  });
};